import React from 'react';

const SvgChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
    <path
      d="M16.29 4.3a1 1 0 1 1 1.41 1.42l-8 8a1 1 0 0 1-1.41 0l-8-8A1 1 0 1 1 1.7 4.3l7.29 7.29z"
      fillRule="evenodd"
    />
  </svg>
);

export default SvgChevronDown;
